export class widgetStatistics {

  static sendUserRedirectionStatisticsEvent(tabName: string, clickType: string, redirectionUrl: string) {
      const label = [
        tabName ? ('tab:' + tabName) : '',
        'clickType:' + clickType, //right, left, keyboard
        redirectionUrl ? 'redirectionUrl:' + redirectionUrl : ''
      ].join('###');

      return this.__trackClick(label);
  }

  private static __trackClick(label) {
      return {
        category: 'widget-cta-support-button',
        action: 'click',
        label: label
      };
  }
}


